<template>
  <div>
    <Form
      :description-title="'Registre uma nova manutenção'"
    >
      <CreateButton
        @click="registerMaintenance()"
        :icon="PhGearSix"
        :label="'Registrar'"
      />
    </Form>
  </div>
</template>

<script setup>
import ExtinguisherService from '../../service/extinguisher.service'
import CreateButton from '@/components/Buttons/Create.vue'
import Form from './Checklist.vue'
import { cleanAllFormFields, setFormFieldsError, validateFormField } from '@/helpers/formFieldsHandler'
import { showToast as toast } from '@/helpers/UseToasts'
import { dataExtinguisher } from '../../store'
import { storeApp } from '@/store'
import * as yup from '@/validator'
import {
  PhGearSix
} from "@phosphor-icons/vue";

const store = dataExtinguisher.state
const appStore = storeApp.state

const schema = yup.object().shape({
  maintenanceForm: yup.object().shape({
    type: yup.string().required('Informe o tipo do documento').label('Tipo')
  })
})

async function registerMaintenance () {
  appStore.loading = true

  cleanAllFormFields()

  const validate = (await validateFormField(schema, store))
  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.loading = false
    return
  }

  // fluxo da imagem
  if (
    store.maintenanceForm.values.images &&
    typeof store.maintenanceForm.values.images === 'object' &&
    typeof store.maintenanceForm.values.imagesName === 'string'
  ) {
    await ExtinguisherService.saveImage(store.maintenanceForm.values.images)
      .then((res) => {
        store.maintenanceForm.values.images = res.data
      })
      .catch((err) =>
        toast(
          'Aviso',
          'Imagem não foi salva',
          'error'
        )
      )
  } 

  delete store.maintenanceForm.values.imagesName

  await ExtinguisherService.newMaintenanceByItem(store.itensForm.id, store.maintenanceForm)
    .then(res => {
      appStore.loading = false
      if (res?.data?.success) {
        Promise.allSettled([
          ExtinguisherService.getMaintenancesByItemId(store.itensForm.id)
            .then(res => {
              if(res?.data)
                dataExtinguisher.dispatch('setMaintenances', res?.data)
            }).catch(err => {
              storeApp.state.loading = false

              if (err?.response?.data?.error) {
                return toast(
                  'Aviso',
                  err.response.data.message,
                  'error'
                )
              }
            
              return toast(
                'Aviso',
                'Algo deu errado ao buscar manutenções',
                'error'
              )
            })
        ])
        
        return toast(
        'Sucesso',
        res.data.message,
        'success'
        )
      }
    }).catch(err => {
      appStore.loading = false

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado ao registrar documento',
        'error'
      )
    })
}

</script>
